// -- other --
import {useState,useEffect} from "react";
import ImageWithBasePath from '../../core/img'
import {all_routes} from '../router/all_routes'
import {Toaster} from 'react-hot-toast';
import {Link} from 'react-router-dom'
// -- biz9 --
import {UrlQuery} from "biz9-react-utility";
import {Log,Response_Logic,DateTime} from "biz9-utility";
import {Image_Format} from "biz9-image";
import {Data_Logic} from "biz9-data-app";
import {Message,Config} from "../../constant";
import {App,Field_Logic,Image,Toast_Message,Storage} from "../../project";
import SubValue from "../subValue";
import {Portal_Type,Portal_Field,Portal_Table,Portal_Stat,Portal_Page,Sub_Value_Logic,Portal_Url,Portal_Value_Type,Portal_Remote_Page,Portal_Remote_Data,Sub_Value_Type} from "biz9-portal-app";

const Blog_Post = () => {
    /* -- DEFINE -- *
     * --- PAGE-EDIT-FIELDS ---
     *
    */
   // -- const --
   const query = UrlQuery();
   const [blog_posts, setBlogPosts]= useState([]);
    // -- page-edit --
 const [sub_value_edit,setSubValueEdit] = useState(Sub_Value_Logic.get_sub_value_edit(Portal_Table.PAGE,0));
 const [page,setPage] = useState(Data_Logic.get(Portal_Table.PAGE,0));
 const [sub_value_group,setSubValueGroup] = useState(Sub_Value_Logic.get_test_sub_value_group({count:50,show_value:false}));
 const [edit_mode,setEditMode] = useState(false);
    useEffect(() => {
        Toast_Message.loading(Message.LOADING);
        get_items_data();
    },[]);
    useEffect(() => {
        Toast_Message.loading(Message.LOADING);
        get_page_data();
    },[]);
    async function get_page_data() {
        // -- remote-data-response --
        let option = {get_cache:false,time_limit:10};
        const [response,data] = await Portal_Remote_Page.get(App.get_url(Portal_Url.PAGE_GET),Portal_Page.BLOG_POST_HOME.title_url,option);
        bind_page(data);
    };
    async function get_items_data() {
        // -- remote-data-response --
        let option = {get_cache:false,time_limit:10};
        let  search = Data_Logic.get_search(Portal_Table.BLOG_POST,{});
        const [response,data] = await Portal_Remote_Page.get_blog_post_home_items(App.get_url(Portal_Page.BLOG_POST_HOME[Portal_Type.ITEMS_URL]),search,option);
        bind_items(data);
        Toast_Message.dismiss();
    }
    async function bind_page(data) {
        // -- page --
        setPage(data[Portal_Type.PAGE]);
        // -- page-edit --
        setEditMode(query.get('edit_mode'));
        setSubValueEdit(Sub_Value_Logic.get_sub_value_edit(Portal_Table.PAGE,data[Portal_Type.PAGE].id));
        // -- sub-values --
        bind_sub_values(data[Portal_Type.SUB_VALUE_GROUP]);
    };
	async function bind_items(data) {
        // -- blog_posts --
        setBlogPosts(data[Portal_Type.BLOG_POSTS]);
	}
    //* ---- BIND-SUB-VALUES ----
    async function bind_sub_values(data_sub_group) {
        // -- sub-values --
        for(const sub_group in data_sub_group){
            if(data_sub_group[sub_group].type != Sub_Value_Type.ITEMS){
                sub_value_group[Portal_Type.SUB_VALUE_UNDER_SCORE+data_sub_group[sub_group].value_id].value = data_sub_group[sub_group].value;
            }else{
                sub_value_group[Portal_Type.SUB_VALUE_UNDER_SCORE+data_sub_group[sub_group].value_id].items = data_sub_group[sub_group].items;
            }
        }
        Storage.post_sub_value_group(sub_value_edit,data_sub_group);
    };
    //* ---- UPDATE-SUB-VALUE ----
     async function update_sub_value(sub_value) {
        // -- page-edit-sub-values --
        if(sub_value.type != Sub_Value_Type.ITEMS){
            setSubValueGroup(sub_value_group => ({
                ...sub_value_group,
                    [Portal_Type.SUB_VALUE_UNDER_SCORE+sub_value.value_id]: {
                    ...sub_value_group[Portal_Type.SUB_VALUE_UNDER_SCORE+sub_value.value_id],
                    value: sub_value.value
                }
            }));
        }else{
            setSubValueGroup(sub_value_group => ({
                ...sub_value_group,
                    [Portal_Type.SUB_VALUE_UNDER_SCORE+sub_value.value_id]: {
                    ...sub_value_group[Portal_Type.SUB_VALUE_UNDER_SCORE+sub_value.value_id],
                    items: sub_value.items
                }
            }));
        }
    }

   const [selectedItems, setSelectedItems] = useState(Array(10).fill(false));
    const handleItemClick = (index: number) => {
        setSelectedItems((prevSelectedItems) => {
                const updatedSelectedItems = [...prevSelectedItems];
                updatedSelectedItems[index] = !updatedSelectedItems[index];
                return updatedSelectedItems;
                });
    };
    return (
            <>
            {/* Breadcrumb */}
            <div className="breadcrumb-bar">
            <div className="breadcrumb-img">
            <div className="breadcrumb-left">
            <ImageWithBasePath src="/assets/img/bg/breadcrump-bg-01.png" alt="img" />
            </div>
            </div>
            <div className="container">

            <div className="row">
            <div className="col-md-12 col-12">
            <nav aria-label="breadcrumb" className="page-breadcrumb">
            <ol className="breadcrumb">
            <li className="breadcrumb-item">
            <Link to={all_routes.home}>Home</Link>
            </li>
            <li className="breadcrumb-item" aria-current="page">
    {sub_value_group.sub_value_1.value}
            </li>
                </ol>
                </nav>
                <h2 className="breadcrumb-title">
            {edit_mode?Field_Logic.get_sub_value_edit_link(sub_value_edit,Sub_Value_Type.TEXT,1):""}
    {sub_value_group.sub_value_1.value}
 </h2>
                </div>
                </div>

                </div>
                <div className="breadcrumb-img">
                <div className="breadcrumb-right">
                <ImageWithBasePath src="/assets/img/bg/breadcrump-bg-02.png" alt="img" />
                </div>
                </div>
                </div>
                {/* /Breadcrumb */}
            {/* Page Content */}
            <div className="page-content">
                <div className="container">
                {/* Blogs */}
            <div className="blog">
                <div className="row">
                {/* Blog */}
            {blog_posts.map((item) => (
                        <div className="col-lg-6">
                        <div className="blog-grid">
                        <div className="blog-img">
                        <Link to={"/blog/"+item.title_url}>
                        <ImageWithBasePath
                        src={Image.get_url(item.image_filename,Image_Format.SQUARE_THUMB)}
                        className="img-fluid"
                        alt="img"
                        />
                        </Link>
                        </div>
                        <div className="blog-content">
                        <div className="user-head">
                        <div className="badge-text">
                        <Link to="#" className="badge bg-primary-light">
                        {item.category}
                        </Link>
                        </div>
                        </div>
                        <div className="blog-title">
                        <h3 className="mb-2">
                        <Link to={"/blog/"+item.title_url}>
                        {item.title}
                        </Link>
                            </h3>
                            <p>
                            {item.description}
                        </p>
                            </div>
                            <div className="blog-content-footer d-flex justify-content-between align-items-center">
                            <div className="user-info">
                            <div className="d-flex align-items-center">
                            <p className="me-2">
                            <Link to={"#"}>{item.author}</Link>
                            </p>
                            <span className="dot me-2" />
                            <span>{DateTime.get_date_short(item.date_create)}</span>
                            </div>
                            </div>
                            </div>
                            </div>
                            </div>
                            </div>
                            ))}
            {/* /Blog */}
            </div>
                </div>
                {/* /Blogs */}
            </div>
     <SubValue sub_value_edit={sub_value_edit} edit_mode={edit_mode} update_sub_value={update_sub_value}  />

               </div>
                {/* /Page Content */}
            </>
                )
}
export default Blog_Post
